import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";

export const ModuloCard = ({ modulo, index, onDelete, onEdit }) => {
  const {
    idModulo,
    nombre = "N/D",
    sigla = "N/D",
    idioma = { nombre: "Sin idioma" },
    nivel = { nombre: "Sin nivel" },
    estado = "Sin estado",
  } = modulo;

  const estadoClase = estado === "Vigente"
    ? "bg-green-100 text-green-700"
    : "bg-red-100 text-red-700";

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 text-sm [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index}</td>
      <td className="border-r border-slate-200 border-t">{nombre}</td>
      <td className="border-r border-slate-200 border-t">{sigla}</td>
      <td className="border-r border-slate-200 border-t">{idioma.nombre}</td>
      <td className="border-r border-slate-200 border-t">{nivel.nombre}</td>
      <td className="border-r border-slate-200 border-t">
        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${estadoClase}`}>
          {estado}
        </span>
      </td>
      <td className="border-slate-200 border-t">
        <div className="flex justify-center gap-3">
          <button
            onClick={() => onEdit?.(idModulo)}
            className="text-green-600 hover:text-green-800"
            title="Editar"
          >
            <EditIcon className="w-5 h-5" />
          </button>
          <button
            onClick={() => onDelete?.(idModulo)}
            className="text-red-600 hover:text-red-800"
            title="Eliminar"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};
